import React, { Component } from "react";
import { GET, t } from "./CustomComponent.js";

// ช่องค้นหาภายในเมนู (ใช้บนหน้า Work Request / Work Order)
//
// ค้นเฉพาะเอกสารของเมนูที่เปิดอยู่ (prop `scope`) ไม่ค้นข้ามเมนู/ข้ามระบบ
// แต่คำค้นครอบคลุมข้อมูลที่เกี่ยวข้องของเอกสารทั้งหมด (เลขที่, ลูกค้า, ทรัพย์สิน, S/N, part master, ผู้ติดต่อ, หมวด, ประเภทงาน, ช่าง ฯลฯ)
//
// - พิมพ์แล้วกด Enter = กรองตารางของหน้าปัจจุบัน (onEnter)
// - พิมพ์แล้วรอสักครู่ = dropdown แนะนำผลลัพธ์จาก /admin/global-search?scope=... (เงื่อนไขค้นชุดเดียวกับตาราง)
// - เลือกจาก dropdown = เติมเลขที่เอกสารลงช่องแล้วกรองตารางให้ (onSelect)

// คำค้นสั้นกว่านี้ผลลัพธ์กว้างเกินจนไม่ช่วยอะไร (ตรงกับฝั่ง backend)
const MIN_KEYWORD_LENGTH = 2;
const DEBOUNCE_MS = 350;

export default class GlobalSearchBox extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false, loading: false, items: [] };
        this.timer = null;
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        if (this.timer) clearTimeout(this.timer);
    }

    // คลิกที่อื่นให้ปิด dropdown - ไม่งั้นผลลัพธ์ค้างทับ UI อื่น
    handleClickOutside = (event) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ open: false });
        }
    };

    handleChange = (event) => {
        const value = event.target.value;
        this.props.onChange(value);

        if (this.timer) clearTimeout(this.timer);
        if (value.trim().length < MIN_KEYWORD_LENGTH) {
            this.setState({ open: false, items: [] });
            return;
        }
        // หน่วงไว้ก่อนยิง API กันยิงทุกตัวอักษรที่พิมพ์
        this.timer = setTimeout(() => this.fetchResults(value.trim()), DEBOUNCE_MS);
    };

    fetchResults = async (keyword) => {
        this.setState({ loading: true, open: true });
        const result = await GET("admin/global-search", { q: keyword, scope: this.props.scope });
        const groups = result?.status && Array.isArray(result?.data?.groups) ? result.data.groups : [];
        // backend คืนกลุ่มเดียวตาม scope - แบนเป็นรายการเดียวพอ
        const items = groups.flatMap((group) => group.items || []);
        // ผู้ใช้อาจพิมพ์ต่อระหว่างรอ - ถ้าคำค้นเปลี่ยนไปแล้วอย่าเอาผลเก่ามาทับ
        if (String(this.props.value || "").trim() !== keyword) return;
        this.setState({ items, loading: false });
    };

    // เลือกรายการ = เติมเลขที่เอกสารลงช่องค้นหา แล้วให้หน้านั้นกรองตารางต่อ (ไม่ย้ายหน้า)
    selectItem = (item) => {
        this.setState({ open: false });
        const code = item.code || item.title || "";
        this.props.onChange(code);
        if (this.props.onSelect) this.props.onSelect(item);
        else this.props.onEnter();
    };

    render() {
        const { value, onEnter, placeholder } = this.props;
        const { open, loading, items } = this.state;

        return (
            <div className="position-relative" ref={this.wrapperRef}>
                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary">{""}</span>
                <input
                    type="text"
                    className="form-control ps-5 wpx-300"
                    style={{ height: "38px" }}
                    placeholder={placeholder || t("search")}
                    value={value}
                    onChange={this.handleChange}
                    onFocus={() => items.length && this.setState({ open: true })}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            this.setState({ open: false });
                            onEnter();
                        }
                        if (e.key === "Escape") this.setState({ open: false });
                    }}
                />

                {open && (
                    <div
                        className="position-absolute bg-white border rounded-3 shadow mt-1 w-100"
                        style={{ zIndex: 1050, maxHeight: 380, overflowY: "auto", minWidth: 320 }}
                    >
                        {loading && <div className="p-3 text-secondary text-14">{t("searching")}</div>}

                        {!loading && !items.length && <div className="p-3 text-secondary text-14">{t("no_data_found")}</div>}

                        {!loading &&
                            items.map((item) => (
                                <button
                                    key={item.uid}
                                    type="button"
                                    className="btn btn-white text-start w-100 border-0 rounded-0 px-3 py-2"
                                    onClick={() => this.selectItem(item)}
                                >
                                    <div className="fw-bold text-dark text-14">{item.code}</div>
                                    {item.title && <div className="text-secondary text-12">{item.title}</div>}
                                </button>
                            ))}
                    </div>
                )}
            </div>
        );
    }
}
